import getSpamScenarioStore from '../selectors/getSpamScenarioStore';
import { SpamScenarioId } from 'owa-junkmail-configuration';
import { mutatorAction } from 'satcheljs';

export const setErrorMessage = mutatorAction(
    'setErrorMessage',
    (spamScenarioId: SpamScenarioId, errorMessage: string) => {
        const store = getSpamScenarioStore(spamScenarioId);
        store.errorMessage = errorMessage;
    }
);
